// Maps floorplan type (e.g. '01') to available level view image filenames
export const levelViewsData = {
  '01': [{ label: 'Level 1', img: '101.jpg' }],
  '02': [{ label: 'Level 1', img: '102.jpg' }],
  '03': [{ label: 'Level 1', img: '103.jpg' }],
  '04': [{ label: 'Level 1', img: '104.jpg' }],
  '05': [{ label: 'Level 1', img: '105.jpg' }],
  '06': [{ label: 'Level 1', img: '106.jpg' }],
  '07': [{ label: 'Level 1', img: '107.jpg' }],
  '08': [
    { label: 'Level 2', img: '201.jpg' },
    { label: 'Level 3', img: '301.jpg' },
    { label: 'Level 4', img: '401.jpg' },
  ],
  '09': [
    { label: 'Level 2', img: '202.jpg' },
    { label: 'Level 3', img: '302.jpg' },
    { label: 'Level 4', img: '402.jpg' },
  ],
  '10': [
    { label: 'Level 2', img: '203.jpg' },
    { label: 'Level 3', img: '303.jpg' },
    { label: 'Level 4', img: '403.jpg' },
  ],
  '11': [
    { label: 'Level 2', img: '204.jpg' },
    { label: 'Level 3', img: '304.jpg' },
    { label: 'Level 4', img: '404.jpg' },
  ],
  '12': [
    { label: 'Level 2', img: '205.jpg' },
    { label: 'Level 3', img: '305.jpg' },
    { label: 'Level 4', img: '405.jpg' },
    { label: 'Level 5', img: '502.jpg' },
  ],
  '13': [
    { label: 'Level 2', img: '206.jpg' },
    { label: 'Level 3', img: '306.jpg' },
    { label: 'Level 4', img: '406.jpg' },
    { label: 'Level 5', img: '503.jpg' },
  ],
  '14': [
    { label: 'Level 2', img: '207.jpg' },
    { label: 'Level 3', img: '307.jpg' },
    { label: 'Level 4', img: '407.jpg' },
  ],
  '15': [
    { label: 'Level 2', img: '208.jpg' },
    { label: 'Level 3', img: '308.jpg' },
    { label: 'Level 4', img: '408.jpg' },
    { label: 'Level 5', img: '505.jpg' },
  ],
  '16': [
    { label: 'Level 2', img: '209.jpg' },
    { label: 'Level 3', img: '309.jpg' },
    { label: 'Level 4', img: '409.jpg' },
    { label: 'Level 5', img: '506.jpg' },
  ],
  '17': [{ label: 'Level 5', img: '501.jpg' }],
  '18': [{ label: 'Level 5', img: '504.jpg' }],
};
